/**
 * @generated SignedSource<<a3b84330c3ecfa05064d9b4e3a523bde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePoll",
    "kind": "LinkedField",
    "name": "votePoll",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "options",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optionVotesCounts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pollVotesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "votedByCurrentUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "votedOptionIndex",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pollDisplayVotePollMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pollDisplayVotePollMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "227f5dfcdc3834b424e78ee41bbd64e8",
    "id": null,
    "metadata": {},
    "name": "pollDisplayVotePollMutation",
    "operationKind": "mutation",
    "text": "mutation pollDisplayVotePollMutation(\n  $request: VotePollRequestInput!\n) {\n  votePoll(request: $request) {\n    id\n    options\n    optionVotesCounts\n    pollVotesCount\n    votedByCurrentUser\n    votedOptionIndex\n  }\n}\n"
  }
};
})();

node.hash = "8079320c8d62fbf3936c548d4e5c91e2";

module.exports = node;
